module.exports = __webpack_public_path__ + "static/media/8.22ba62f6.mp3";